import { Alert } from './Alert';
import { MainBanner } from './MainBanner';
import { Banner } from './Banner';
import { SimpleProduct } from './SimpleProduct';
import { IntraSection } from './IntraSection';

const SECTION_TYPES = {
  BANNER: 'banner',
  MAIN_BANNER: 'mainBanner',
  PRODUCT_LIST: 'productList',
  INTRA: 'intra',
};

class Home {
  static buildSection(data) {
    const isMainBanner = data.type === SECTION_TYPES.MAIN_BANNER;
    const isBanner = data.type === SECTION_TYPES.BANNER;
    const isProductList = data.type === SECTION_TYPES.PRODUCT_LIST;
    const isIntraSection = data.type === SECTION_TYPES.INTRA;
    const genericValues = {
      id: data.id,
      name: data.name,
      index: data.index,
      type: data.type,
    };
    if (isMainBanner) {
      return {
        ...genericValues,
        banners: (data.banners || []).map(bannerData => new MainBanner(bannerData)),
      };
    } else if (isBanner) {
      return {
        ...genericValues,
        banners: (data.banners || []).map(bannerData => new Banner(bannerData)),
      };
    } else if (isProductList) {
      return {
        ...genericValues,
        products: data.products.map(productData => new SimpleProduct(productData)),
      };
    } else if (isIntraSection) {
      return {
        ...genericValues,
        sectionsIntra: data.sectionsIntra.sort((a, b) => (a.order < b.order ? -1 : 1))
          .map(intraSection => new IntraSection(intraSection)),
      };
    }
    return null;
  }

  constructor(params) {
    this.alert = null;
    if (params.alert) {
      this.alert = new Alert(params.alert);
    }
    this.sections = (params.sections || []).map(Home.buildSection);
  }
}

export { Home, SECTION_TYPES };



// WEBPACK FOOTER //
// ./src/models/Home.js